import { inject, InjectionToken } from '@angular/core';
import {distinctUntilChanged, filter, map, shareReplay} from 'rxjs/operators';
import { ReputationConfig } from '@galaxy/reputation';
import { AccountGroupService } from '../account-group';
import { checkFeatureStatus$ } from '@vendasta/protos/reputation/v1/feature-set-service';
import {switchMap} from "rxjs";
import { FeatureFlagService } from '../core/feature-flag.service';
export const REPUTATION_CONFIG = new InjectionToken<ReputationConfig>(
  '[Business Center Client]: Token for Reputation config',
  {
    providedIn: 'root',
    factory: function (): ReputationConfig {
      const accountGroupService = inject(AccountGroupService);
      const featureFlagService = inject(FeatureFlagService);

      const accountGroupId$ = accountGroupService.currentAccountGroup$.pipe(
        map((ag) => ag?.accountGroupId),
        filter<string>(Boolean),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );

      const partnerId$ = accountGroupService.currentAccountGroup$.pipe(
        map((ag) => ag?.partnerId),
        filter<string>(Boolean),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );

      const hasAutoReviewAccess$ = accountGroupId$.pipe(
        switchMap((accountGroupId) =>
          checkFeatureStatus$({
            accountGroupId: accountGroupId,
            featureIds: ['auto_review_response'],
          })
        ),
        map((featureStatusResponse) =>
          featureStatusResponse.featureStatus['auto_review_response'] || false
        ),
        shareReplay({ refCount: true, bufferSize: 1 })
      );

      const isDraftReviewResponseEnabled$ = partnerId$.pipe(
        switchMap((partnerId) => featureFlagService.checkFeatureFlag(partnerId, '', 'draft_review_response')),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );

      return {
        isBusinessApp: true,
        accountGroupId$,
        partnerId$,
        hasAutoReviewAccess$,
        isDraftReviewResponseEnabled$,
      };
    },
  },
);
